<template>
  <div>
    <section class="section">
      <div class="container">
        <BaseTitle>
          Choix du mot de passe
        </BaseTitle>

        <form
          class="max-w-md m-auto"
          @submit.prevent="submit"
        >
          <b-field
            class="mb-8"
            label="Mot de passe"
          >
            <b-input
              v-model="form.password"
              type="password"
              placeholder="Mot de passe"
              minlength="8"
              required
              password-reveal
            />
          </b-field>
          <div class="text-center">
            <b-button
              type="is-primary"
              native-type="submit"
              class="mb-4"
            >
              Valider
            </b-button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapGetters } from 'vuex';
import BaseTitle from '../components/BaseTitle.vue';

export default {
  name: 'PasswordReset',
  components: {
    BaseTitle,
  },
  computed: {
    ...mapFields('authentication', ['form']),
    ...mapGetters('authentication', ['connected']),
  },
  methods: {
    ...mapActions('authentication', ['resetPassword']),
    submit() {
      this.resetPassword({ token: this.$route.query.reset_password_token })
        .then(() => {
          let message = 'Votre mot de passe a bien été enregistré';
          if (this.connected) {
            this.$router.replace('/');
          } else {
            this.$router.replace(`/connexion?redirect=${this.$router.currentRoute.path}`);
            message += '. veuillez vous connecter pour continuer';
          }
          this.$buefy.toast.open({
            message,
            type: 'is-success',
            position: 'is-bottom',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: 'Demande de création de compte expirée, veuillez nous contacter',
            type: 'is-danger',
            position: 'is-bottom',
            duration: 5000,
          });
        });
    },
  },
};
</script>
